var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      staticStyle: {
        "border-radius": "4px !important",
        border: "1px solid #dee5ec",
        "margin-right": "12px",
      },
      attrs: { shadow: "never", "body-style": "margin: 0px;" },
    },
    [
      _c("div", [
        _c(
          "div",
          {
            staticClass: "flex flex-row",
            staticStyle: { margin: "8px 24px 8px 8px" },
          },
          [
            _vm.devicePicture && _vm.devicePicture.src
              ? _c("img", {
                  staticStyle: { width: "80px", height: "80px" },
                  attrs: {
                    alt: _vm.devicePicture.alt,
                    src: _vm.devicePicture.src,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex-1", staticStyle: { margin: "8px" } },
              [
                _c("div", { staticClass: "flex flex-row" }, [
                  _c(
                    "div",
                    {
                      staticClass: "item-name flex-1",
                      staticStyle: {
                        "white-space": "nowrap",
                        overflow: "hidden",
                        "text-overflow": "ellipsis",
                      },
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(_vm.title) + "\n          "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "item-sku" }, [
                  _c("strong", [_vm._v("ASIN: ")]),
                  _vm._v(" " + _vm._s(_vm.sku) + "\n        "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "item-status",
                    class:
                      "item-status-" +
                      _vm.status.replaceAll(" ", "-").toLowerCase(),
                  },
                  [_vm._v("\n          " + _vm._s(_vm.status) + "\n        ")]
                ),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }